var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row"},_vm._l((_vm.images),function(image){return _c('div',{staticClass:"col-md-2 col-sm-3 col-4 col-lg-1 mb-5"},[_c('img',{staticStyle:{"max-width":"100%"},attrs:{"src":image}})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }